import React from 'react';
import { usePlayerAvailabilityTimeline } from '../../hooks/usePlayerDetails';
import { cn } from '../../lib/utils';
import { PlayerSeasonTimeline } from './PlayerSeasonTimeline';

interface PlayerAvailabilityTimelineProps {
  playerId: string;
  className?: string;
}

export const PlayerAvailabilityTimeline: React.FC<PlayerAvailabilityTimelineProps> = ({
  playerId,
  className
}) => {
  const { data, isLoading, error } = usePlayerAvailabilityTimeline(playerId);

  if (isLoading) {
    return (
      <div className={cn("flex justify-center items-center py-8", className)}>
        <div className="animate-spin rounded-full h-8 w-8 border-2 border-[#4E46FF] border-t-transparent"></div>
      </div>
    );
  }

  if (error || !data || !data.timeline || data.timeline.length === 0) {
    return (
      <div className={cn("text-center text-[#CECFD2] py-4", className)}>
        No availability data available
      </div>
    );
  }

  const { timeline, average_bradford_factor } = data;

  return (
    <div className={cn("space-y-4", className)}>
      <div className="flex justify-between items-center mb-3">
        <h4 className="text-lg font-bold text-[#CECFD2]">
          Availability Timeline
        </h4>
        <div className="text-lg text-[#CECFD2]">
          Average Bradford Factor: <span className="font-bold">{average_bradford_factor.toFixed(2)}</span>
        </div>
      </div>
      
      {/* Season Timelines */}
      <div className="space-y-4">
        {timeline.map((season) => (
          <PlayerSeasonTimeline key={season.season} seasonData={season} />
        ))}
      </div>
    </div>
  );
};